var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEigenheimIconsComp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.12 46.31H4.62V5.84A4.83 4.83 0 019.45 1h58.84a4.83 4.83 0 014.83 4.84v40.47z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.12 45.31H5.62V5.84A3.84 3.84 0 019.45 2h58.84a3.84 3.84 0 013.83 3.84v39.47zM68.29 0H9.45a5.84 5.84 0 00-5.83 5.84v40.47a1.23 1.23 0 000 .2H74.1a1.23 1.23 0 000-.2V5.84A5.84 5.84 0 0068.29 0z",
    fill: "#546FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.66 49.72a1 1 0 01-1 1H7.08a1 1 0 010-2h63.58a1 1 0 011 1z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.22 51.54H5.52A3.53 3.53 0 012 48a1.52 1.52 0 011.52-1.51h70.7A1.52 1.52 0 0175.74 48a3.53 3.53 0 01-3.52 3.52v.02zM76 46.25a2.49 2.49 0 00-1.78-.74H3.52A2.52 2.52 0 001 48a4.51 4.51 0 004.52 4.52h66.7A4.52 4.52 0 0076.74 48a2.47 2.47 0 00-.74-1.75z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.22 51.54H5.52A3.53 3.53 0 012 48a1.52 1.52 0 011.52-1.51h70.7A1.52 1.52 0 0175.74 48a3.53 3.53 0 01-3.52 3.52v.02zm2-7H3.52A3.52 3.52 0 000 48a5.52 5.52 0 005.52 5.52h66.7A5.52 5.52 0 0077.74 48a3.52 3.52 0 00-3.52-3.51v.05z",
    fill: "#546FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.66 50.72H7.08a1 1 0 010-2h63.58a1 1 0 010 2zm3.56-4.21H3.52A1.52 1.52 0 002 48a3.53 3.53 0 003.52 3.52h66.7A3.53 3.53 0 0075.74 48a1.52 1.52 0 00-1.52-1.51v.02z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.66 49.72a1 1 0 01-1 1H7.08a1 1 0 010-2h63.58a1 1 0 011 1z",
    fill: "#546FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.33 42H12.41A3.42 3.42 0 019 38.53V9.25a3.42 3.42 0 013.42-3.42h52.91a3.42 3.42 0 013.42 3.42v29.28A3.422 3.422 0 0165.33 42z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.41 6.83A2.43 2.43 0 0010 9.25v29.28A2.423 2.423 0 0012.41 41h52.92a2.42 2.42 0 002.42-2.42V9.25a2.42 2.42 0 00-2.42-2.42H12.41zM65.33 43H12.41A4.42 4.42 0 018 38.53V9.25a4.42 4.42 0 014.42-4.42h52.91a4.42 4.42 0 014.42 4.42v29.28A4.421 4.421 0 0165.33 43z",
    fill: "#546FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.38 4.6h-5a1 1 0 010-2h5a1 1 0 010 2z",
    fill: "#8099E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.56 17h-22.4a1 1 0 010-2h22.4a1 1 0 010 2zm0 8.65h-22.4a1 1 0 010-2h22.4a1 1 0 010 2zm0 8.23h-22.4a1 1 0 010-2h22.4a1 1 0 010 2z",
    fill: "#546FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2CFE0",
    d: "M31.87 32.88H17.75V15.83h14.12v17.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 31.88h12.12v-15H18.75v15zm13.12 2H17.75a1 1 0 01-1-1V15.83a1 1 0 011-1h14.12a1 1 0 011 1v17.05a1 1 0 01-1 1z",
    fill: "#546FBB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEigenheimIconsComp);
export default __webpack_public_path__ + "static/media/eigenheim_icons_comp.eb9132b3f20e03cecd9cfb1731b403e4.svg";
export { ForwardRef as ReactComponent };